import { useUserBridgeStore } from '../store/userBridge';
import { usePlanningStore } from '../store';
import { useDayStore } from '../store/useDayStore';

export function useDutyFormValidator() {
	const { checkPermisions } = useUserBridgeStore();
	const planningStore = usePlanningStore();
	const dayStore = useDayStore();
	const evaluateEditPermissions = (date, duty, dutyDetails = {}) => {
		const canEditDuties = checkPermisions('duties.edit');
		let editableField = [];
		let canPartialEdit = false;

		// Default object format we will return when permissions fail
		const fallbackResponse = {
			hasEditPermission: false,
			editableField: [],
			canPartialEdit: false,
		};

		// const formattedDate = date?.toISODate();

		if (!dayStore.days[date]) {
			// No permission (duty hasn't been loaded)
			return fallbackResponse;
		}

		const hasEditPermission = planningStore.canEditDutyForDate(date);

		// Disable editing particular absence duties
		if (hasEditPermission && duty?.provider === 'absence') {
			const isEditableAbsenceType = duty?.nameKey === 'duty_absence_education' || duty?.nameKey === 'duty_absence_work';
			// These fields are passed to edit them when the absences are only work and education
			if (isEditableAbsenceType) {
				editableField = ['start', 'end', 'breaks'];
				canPartialEdit = true;
			}

			// Returning multiple properties even if global permission is false
			return {
				hasEditPermission: false,
				editableField,
				canPartialEdit,
			};
		}

		// Standard baseline response
		return {
			hasEditPermission,
			editableField,
			canPartialEdit,
		};
	};

	return {
		evaluateEditPermissions,
	};
}

// const canEditDuties = this.checkPermission('duties.edit');
// 			this.editableField = [];

// 			// Enable Editing duty template
// 			if (!date || this.isTemplate) {
// 				return canEditDuties;
// 			}

// 			const formattedDate = date?.toISODate();
// 			if (!this.planningDays[formattedDate]) {
// 				// No permission (duty hasn't been loaded) -> return false
// 				return false;
// 			}

// 			const hasEditPermission = this.canEditDutyForDate(formattedDate);

// 			// Disable editing particular absence duties
// 			if (hasEditPermission && this.dutyDetails?.provider === 'absence') {
// 				const isEditableAbsenceType = this.data?.nameKey === 'duty_absence_education' || this.data?.nameKey === 'duty_absence_work';

// 				// these fields are passed to edit them when the absences are only work and education, for the time being relying on namekey.
// 				if (isEditableAbsenceType) {
// 					this.editableField = ['startTime', 'endTime', 'breaks'];
// 					this.canPartialEdit = true;
// 				}
// 				return false;
// 			}

// 			return hasEditPermission;
